/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getGeoSellers} from '../api'

 export const useQueryGetGeoSellers = createReactQueryHook('getGeoSellers', getGeoSellers)
